import React from "react";
// import s from "./style.module.css";
import Page from "../../layouts/Page";
import ContentBlock from "../../components/ContentBlock";
import ExternalLinkList from "../../components/ExternalLinkList";
import InternalNavigation from "../../components/InternalNavigation";
import LaunchBanner from "../../components/LaunchBanner";
import ScrollToHash from "../../helpers/scrollToHash";
import { ReactComponent as Blogs } from "../../components/Icons/blogs.svg";
import { ReactComponent as DataAnalysis } from "../../components/Icons/dataanalysis.svg";
import { ReactComponent as Country } from "../../components/Icons/country.svg";
import Header from "./header.svg";
const copy = require(`./copy/${process.env.REACT_APP_LANG}`);

const DataAndResearchPage = () => {
  return (
    <Page
      meta={copy.meta}
      title={copy.title}
      intro={copy.intro}
      image={Header}
      beforeHeader={
        <>
          {copy.banner?.text && (
            <LaunchBanner text={copy.banner.text} url={copy.banner.url} />
          )}
        </>
      }
    >
      <ScrollToHash />
      <InternalNavigation items={copy.sections} />

      {copy.dataAndAnalysis && (
        <ContentBlock
          {...copy.dataAndAnalysis}
          icon={<DataAnalysis />}
          id="dataAndAnalysis"
        >
          <ExternalLinkList items={copy.dataAndAnalysis.links} />
        </ContentBlock>
      )}

      {copy.backgroundResearch && (
        <ContentBlock
          {...copy.backgroundResearch}
          icon={<Blogs />}
          id="backgroundResearch"
        >
          <ExternalLinkList items={copy.backgroundResearch.links} />
        </ContentBlock>
      )}

      {copy.countryCaseStudies && (
        <ContentBlock
          {...copy.countryCaseStudies}
          id="countryCaseStudies"
          icon={<Country />}
        >
          <ExternalLinkList items={copy.countryCaseStudies.links} />
        </ContentBlock>
      )}
    </Page>
  );
};

export default DataAndResearchPage;
